<div class="bg-red-500 w-full text-center text-white font-semibold" *ngIf="maintenanceStatusService.status === MaintenanceStatus.active">
    MANUTENZIONE IN CORSO
</div>
